<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入服务人员姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="身份证号" required prop="idCard">
                                    <el-input v-model="editForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>

                      <el-row class="row">
<!--                        <el-col :span="12" class="item">-->
<!--                          <el-form-item label="状态">-->
<!--                            <el-select v-model="editForm.serviceStatus" placeholder="选择状态" style="width: 100%">-->
<!--                              <el-option-->
<!--                                  v-for="item in status2"-->
<!--                                  :key="item.value"-->
<!--                                  :label="item.label"-->
<!--                                  :value="item.value">-->
<!--                              </el-option>-->
<!--                            </el-select>-->
<!--                          </el-form-item>-->
<!--                        </el-col>-->

                      </el-row>

                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import idcardRules from "@/common/idcardRules";

  const validatorIdNumber = (rule, value, callback) => {
  if(value){
    if (idcardRules(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的证件号'))
    }
  }else{
    callback()
  }

};

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                healthCardsFileList:[],
                qualificationFileList:[],

                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadUrl1:this.$shopUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                qualificationImageUrl:'',
                qualificationVisible:false,
                healthCardsImageUrl:'',
                healthCardsVisible:false,
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                serviceTypeValue:['兼职','专职'],
                serviceStatusValue:['正常服务','停止服务'],

              status2: [{
                value: 0,
                label: '默认'
              }, {
                value: 1,
                label: '正常'
              }, {
                value: 2,
                label: '被禁用'
              }],

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),

                    name:'',
                    idCard:'',
                    serveCode:'',

                },

                rules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入商家名称', trigger: 'blur' },
                    ],
                     idCard:[
                        { required: false,validator: validatorIdNumber, trigger: 'blur' }
                    ],

                },

            }
        },

        methods: {
            init(row){
              this.$refs.editForm.resetFields();

              this.editForm.name=row.name
              this.editForm.idCard=row.idCard
              this.editForm.serveCode=row.serveCode

            },
            qualificationBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.qualificationFileList=[]
                    return false;
                }
            },
            healthCardsBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.healthCardsFileList=[]
                    return false;
                }
            },
            qualificationRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.qualification = '';
            },
            qualificationSuccess(res, file) {
                console.log(file)
                this.editForm.qualification = this.$imgUrl+res.data.path;
            },
            qualificationPreview(file) {
                this.qualificationImageUrl = file.url;
                this.qualificationVisible = true;
            },
            healthCardsRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.healthCards = '';
            },
            healthCardsSuccess(res, file) {
                console.log(file)
                this.editForm.healthCards = this.$imgUrl+res.data.path;
            },
            healthCardsPreview(file) {
                this.healthCardsImageUrl = file.url;
                this.healthCardsVisible = true;
            },
            closeSelf() {
                this.healthCardsFileList=[]
                this.qualificationFileList=[]
                this.$emit("closeEdit");
            },
             handleImgSuccess(res, file) {
                 console.log(file)
                this.editForm.img = this.$imgUrl+res.data.path;
            },


            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Serve/EditByBus",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>
<style lang="scss" scoped>

</style>
